/**
 * Signs the DER-encoded SignedAttributes with RSASSA-PKCS1-v1_5/SHA-256.
 * This is the only place the private key is used. WebCrypto hashes and
 * pads internally -- no pre-hashing, no custom padding.
 */
export async function signAttributes(
  privateKey: CryptoKey,
  signedAttrsDer: Uint8Array,
): Promise<Uint8Array> {
  const signature = await crypto.subtle.sign(
    { name: "RSASSA-PKCS1-v1_5" },
    privateKey,
    signedAttrsDer as BufferSource,
  );
  return new Uint8Array(signature);
}
